export const appointments = {

    state: {

        curr: null,
        prev: null,
        next: null,

        appointmentsLoader: false,
        appointments: [],

        mockAppointments: [

            {
                id: 1,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Fluffy',
                animal_type: 'Community Cat (FERAL)',
                animal_species: 'Cat',
                animal_gender: 'Female',
                animal_weight: '51.00'
            },
            {
                id: 2,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Dora',
                animal_type: 'Beagle',
                animal_species: 'Dog',
                animal_gender: 'Female',
                animal_weight: '64.00'
            },
            {
                id: 3,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Fluffy',
                animal_type: 'Community Cat (FERAL)',
                animal_species: 'Cat',
                animal_gender: 'Female',
                animal_weight: '51.00'
            },
            {
                id: 4,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Dora',
                animal_type: 'Beagle',
                animal_species: 'Dog',
                animal_gender: 'Female',
                animal_weight: '64.00'
            },
            {
                id: 5,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Fluffy',
                animal_type: 'Community Cat (FERAL)',
                animal_species: 'Cat',
                animal_gender: 'Female',
                animal_weight: '51.00'
            },
            {
                id: 6,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Dora',
                animal_type: 'Beagle',
                animal_species: 'Dog',
                animal_gender: 'Female',
                animal_weight: '64.00'
            },
            {
                id: 7,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Fluffy',
                animal_type: 'Community Cat (FERAL)',
                animal_species: 'Cat',
                animal_gender: 'Female',
                animal_weight: '51.00'
            },
            {
                id: 8,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Dora',
                animal_type: 'Beagle',
                animal_species: 'Dog',
                animal_gender: 'Female',
                animal_weight: '64.00'
            },
            {
                id: 9,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Fluffy',
                animal_type: 'Community Cat (FERAL)',
                animal_species: 'Cat',
                animal_gender: 'Female',
                animal_weight: '51.00'
            },
            {
                id: 10,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Dora',
                animal_type: 'Beagle',
                animal_species: 'Dog',
                animal_gender: 'Female',
                animal_weight: '64.00'
            },
            {
                id: 11,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Fluffy',
                animal_type: 'Community Cat (FERAL)',
                animal_species: 'Cat',
                animal_gender: 'Female',
                animal_weight: '51.00'
            },
            {
                id: 12,
                client: 'ARGON - CARSON CITY',
                c_number: 'c: 000-000-0000',
                h_number: 'h: 000-000-0000',
                animal_name: 'Dora',
                animal_type: 'Beagle',
                animal_species: 'Dog',
                animal_gender: 'Female',
                animal_weight: '64.00'
            },

        ]

    },

    mutations: {

        setPrevDate( state, prev ) { state.prev = prev },
        setCurrDate( state, curr ) { state.curr = curr },
        setNextDate( state, next ) { state.next = next }, 
        setAppointments( state, appointments ) { state.appointments = appointments },
        setAppointmentsLoader( state, loader ) { state.appointmentsLoader = loader }

    },

    actions: {

        async getAppointments({ rootState, commit, dispatch }, date ) {

            commit( 'setAppointmentsLoader', true )

            if ( rootState.clinics.length === 0 ) await dispatch('getClinics')

            const appointments = await dispatch('fetchy', {
                url: `/api/appointment/${rootState.clinics[0].clientId}/${rootState.clinics[0].clinicId}/list/${ date ? date : '' }`
            })

            console.log(appointments)

            commit( 'setNextDate', appointments.nextDate )
            commit( 'setCurrDate', appointments.currentDate )
            commit( 'setPrevDate', appointments.previousDate )
            commit( 'setAppointments', appointments.appointments )
            commit( 'setAppointmentsLoader', false )

            return appointments

        }

    }

}